var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { renderRoutes } from 'react-router-config';
import { withStyles } from '@material-ui/core/styles';
import { AppBar, Hidden, Icon, IconButton, Toolbar, Drawer, MuiThemeProvider } from '@material-ui/core';
import * as _ from 'lodash';
import { themes } from '../../theme';
import { mainApi } from 'src/config';
import * as classNames from 'classnames';
import Message from '../../components/Message';
import * as Actions from '../../../store/actions';
import Scrollbars from '../../components/Scrollbars';
import { checkIfDevelopmentStage } from 'src/utils/common';
import Sidebar from '../../../components/reusable/Sidebar';
import { isCurrentPageAdminOrUserTasksPage, isCurrentPageNotificationPage } from 'src/utils/common';
var defaultProps = {};
var navbarWidth = 256;
var styles = function (theme) { return ({
    root: {
        transition: 'padding-left 350ms cubic-bezier(0, 0, 0.2, 1) 0ms',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        '&.boxed': {
            maxWidth: 1280,
            margin: '0 auto',
            boxShadow: theme.shadows[3],
        },
        '& table.simple tbody tr td': {
            borderColor: theme.palette.divider,
        },
        '& table.simple thead tr th': {
            borderColor: theme.palette.divider,
        },
        '& a:not([role=button])': {
            // color: theme.palette.secondary.main,
            textDecoration: 'none',
            '&:hover': {
                textDecoration: 'underline',
            },
        },
        '& [class^="border-"]': {
            borderColor: theme.palette.divider,
        },
        '& [class*="border-"]': {
            borderColor: theme.palette.divider,
        },
        '&.scroll-body': {
            '& $wrapper': {
                height: 'auto',
                flex: '0 0 auto',
                overflow: 'auto',
            },
            '& $contentWrapper': {},
            '& $content': {},
        },
        '&.scroll-content': {
            '& $wrapper': {},
            '& $contentWrapper': {},
            '& $content': {},
        },
    },
    sidebarContent: {
        '@media(max-width: 1305px)': {
            paddingLeft: '245px !important',
        },
    },
    wrapper: {
        display: 'flex',
        position: 'relative',
        width: '100%',
        height: '100%',
    },
    contentWrapper: {
        display: 'flex',
        flexDirection: 'column',
        zIndex: 3,
        overflow: 'hidden',
        flex: '1 1 auto',
    },
    content: {
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        width: '100%',
        '-webkit-overflow-scrolling': 'touch',
        overflow: 'auto !important',
    },
    navbarWrapper: {
        boxShadow: theme.shadows[3],
        zIndex: 4,
    },
    navbarPaperWrapper: {},
    navbar: {
        display: 'flex',
        overflow: 'hidden',
        flexDirection: 'column',
        width: navbarWidth,
        minWidth: navbarWidth,
        height: '100%',
        zIndex: 4,
        transition: theme.transitions.create(['width', 'min-width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.shorter,
        }),
    },
    navbarButton: {
        '&.right': {
            borderLeft: '1px solid ' + theme.palette.divider,
        },
        '&.left': {
            borderRight: '1px solid ' + theme.palette.divider,
        },
    },
    navbarLeft: {
        left: 0,
    },
    navbarRight: {
        right: 0,
    },
    navbarFolded: {
        position: 'absolute',
        width: 64,
        minWidth: 64,
        top: 0,
        bottom: 0,
    },
    navbarFoldedOpen: {
        width: navbarWidth,
        minWidth: navbarWidth,
    },
    navbarFoldedClose: {
        '& $navbarHeader': {
            padding: '0 8px 0 13px',
            '& .logo-text': {
                opacity: 0,
            },
            '& .react-badge': {
                opacity: 0,
            },
        },
        '& .list-item-text, & .arrow-icon': {
            opacity: 0,
        },
        '& .list-subheader .list-subheader-text': {
            opacity: 0,
        },
        '& .list-subheader:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            minWidth: 16,
            borderTop: '2px solid',
            opacity: 0.2,
        },
        '& .collapse-children': {
            display: 'none',
        },
    },
    navbarHeaderWrapper: __assign(__assign({ display: 'flex', alignItems: 'center', flex: '0 1 auto' }, theme.mixins.toolbar), { backgroundColor: 'rgba(255, 255, 255, .05)', boxShadow: theme.shadows[1] }),
    navbarHeader: {
        display: 'flex',
        flex: '1 1 auto',
        padding: '0 8px 0 16px',
    },
    navbarContent: {
        overflowX: 'hidden',
        overflowY: 'auto',
        '-webkit-overflow-scrolling': 'touch',
    },
    toolbarWrapper: {
        display: 'flex',
        position: 'fixed',
        zIndex: 1200,
    },
    toolbar: {
        display: 'flex',
        flex: '1 0 auto',
    },
    footerWrapper: {
        position: 'relative',
        zIndex: 5,
    },
    footer: {
        display: 'flex',
        flex: '1 0 auto',
    },
}); };
var Layout1 = /** @class */ (function (_super) {
    __extends(Layout1, _super);
    function Layout1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleToggleFolded = function () {
            _this.props.setDefaultSettings(_.set({}, 'layout.config.navbar.folded', !_this.props.settings.layout.config.navbar.folded));
        };
        return _this;
    }
    Layout1.prototype.render = function () {
        var _this = this;
        var _a = this.props, user = _a.user, classes = _a.classes, toolbar = _a.toolbar, footer = _a.footer, navbarHeader = _a.navbarHeader, navbarContent = _a.navbarContent, settings = _a.settings, navbar = _a.navbar, originalOrgId = _a.originalOrgId, navbarCloseMobile = _a.navbarCloseMobile, navbarOpenFolded = _a.navbarOpenFolded, navbarCloseFolded = _a.navbarCloseFolded;
        var layoutConfig = settings.layout.config;
        // pages
        var isHomePage = window.location.pathname === '/home';
        var isMandatoryPage = window.location.pathname === '/mandatory';
        var isSearchVideosPage = window.location.pathname === '/results';
        var isSubsriptionPage = window.location.pathname === '/subscriptions';
        var isHistoryPage = window.location.pathname === '/history';
        var isLibraryPage = window.location.pathname === '/library';
        var isFavoritePage = window.location.pathname === '/favorites';
        var isSharingPage = window.location.pathname === '/sharings';
        var isMyVideospage = window.location.pathname === '/my-videos';
        var isAdminPage = _.includes(window.location.pathname, '/admin');
        var isFinancePage = _.includes(window.location.pathname, '/finance');
        var isPersistent = isHomePage ||
            isSearchVideosPage ||
            isMandatoryPage ||
            isSubsriptionPage ||
            isHistoryPage ||
            isLibraryPage ||
            isFavoritePage ||
            isSharingPage ||
            isAdminPage ||
            isMyVideospage ||
            isFinancePage ||
            isCurrentPageAdminOrUserTasksPage() ||
            isCurrentPageNotificationPage();
        var navbarHeaderTemplate = (React.createElement("div", { className: classes.navbarHeaderWrapper },
            React.createElement("div", { className: classes.navbarHeader }, navbarHeader),
            React.createElement(Hidden, { mdDown: true },
                React.createElement(IconButton, { id: "menu-btn", onClick: this.handleToggleFolded },
                    React.createElement(Icon, null, "menu"))),
            React.createElement(Hidden, { lgUp: true },
                React.createElement(IconButton, { id: "menu-btn-mobile", onClick: navbarCloseMobile },
                    React.createElement(Icon, null, "menu")))));
        var navbarContentTemplate = React.createElement(Scrollbars, { className: classes.navbarContent }, navbarContent);
        var navBarTemplate = (React.createElement(MuiThemeProvider, { theme: themes[settings.theme.navbar] },
            React.createElement("div", { id: "fuse-navbar", className: classes.navbarWrapper },
                React.createElement(Hidden, { mdDown: true },
                    React.createElement("div", { className: classNames(classes.navbar, classes['navbar' + _.upperFirst(layoutConfig.navbar.position)], layoutConfig.navbar.folded && classes.navbarFolded, layoutConfig.navbar.folded && navbar.foldedOpen && classes.navbarFoldedOpen, layoutConfig.navbar.folded && !navbar.foldedOpen && classes.navbarFoldedClose), onMouseEnter: navbarOpenFolded, onMouseLeave: navbarCloseFolded, style: { backgroundColor: themes[settings.theme.navbar].palette.background.default } },
                        navbarHeaderTemplate,
                        navbarContentTemplate)),
                React.createElement(Hidden, { lgUp: true },
                    React.createElement(Drawer, { anchor: layoutConfig.navbar.position, variant: "temporary", open: navbar.mobileOpen, classes: {
                            paper: classes.navbar,
                        }, onClose: navbarCloseMobile, ModalProps: {
                            keepMounted: true, // Better open performance on mobile.
                        } },
                        navbarHeaderTemplate,
                        navbarContentTemplate)))));
        var isDevStage = checkIfDevelopmentStage();
        var mainApiUrl = mainApi(isDevStage);
        var toolbarTemplate = (React.createElement(MuiThemeProvider, { theme: themes[settings.theme.toolbar] },
            React.createElement(AppBar, { id: "fuse-toolbar", style: { boxShadow: 'none' }, className: classNames(classes.toolbarWrapper), color: "default" },
                React.createElement(Toolbar, { className: "p-0" },
                    React.createElement("div", { className: classes.toolbar }, toolbar)),
                originalOrgId && (React.createElement("div", { onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, axios({
                                        method: 'POST',
                                        url: mainApiUrl.command + "/updateUserOrgSwitch",
                                        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
                                        data: {
                                            orgToSwitchTo: '',
                                        },
                                    })];
                                case 1:
                                    _a.sent();
                                    localStorage.removeItem('collaborationOrgId');
                                    window.location.href = '/home';
                                    return [2 /*return*/];
                            }
                        });
                    }); }, style: {
                        cursor: 'pointer',
                        background: this.props.tubeColor,
                        color: 'white',
                        textAlign: 'center',
                        padding: 5,
                    } }, "You are working in another workspace. Click to move to your own organization")))));
        var footerTemplate = (React.createElement(MuiThemeProvider, { theme: themes[settings.theme.footer] },
            React.createElement(AppBar, { id: "fuse-footer", className: classNames(classes.footerWrapper), color: "default" },
                React.createElement(Toolbar, { className: "p-0" },
                    React.createElement("div", { className: classNames(classes.footer) }, footer)))));
        var isEmbedCodesPage = window.location.pathname.startsWith('/embed/') || window.location.pathname.startsWith('/sharing/');
        var hideSidebar = _.includes(['/login', '/register', '/forgot-password', '/login-lp', '/reset-password', '/auto-login', '/lp'], window.location.pathname);
        switch (layoutConfig.scroll) {
            case 'body': {
                return (React.createElement("div", { id: "fuse-layout", className: classNames(classes.root, layoutConfig.mode, 'scroll-' + layoutConfig.scroll) },
                    !isEmbedCodesPage && !hideSidebar && (React.createElement(Sidebar, { isPersistent: isPersistent, user: user, currentPath: this.props.location.pathname })),
                    React.createElement("div", { style: {
                            background: 'red',
                            zIndex: 2,
                        } },
                        layoutConfig.toolbar.display &&
                            layoutConfig.toolbar.style === 'fixed' &&
                            layoutConfig.toolbar.position === 'above' &&
                            toolbarTemplate,
                        React.createElement(Scrollbars, null,
                            layoutConfig.toolbar.display &&
                                layoutConfig.toolbar.style !== 'fixed' &&
                                layoutConfig.toolbar.position === 'above' &&
                                toolbarTemplate,
                            React.createElement("div", { className: classes.wrapper },
                                layoutConfig.navbar.display && layoutConfig.navbar.position === 'left' && navBarTemplate,
                                layoutConfig.toolbar.display && layoutConfig.toolbar.position === 'below' && toolbarTemplate,
                                React.createElement("div", { className: classNames(classes.contentWrapper, layoutConfig.navbar.display &&
                                        layoutConfig.navbar.folded &&
                                        layoutConfig.navbar.position === 'left' &&
                                        'md:ml-64', layoutConfig.navbar.display &&
                                        layoutConfig.navbar.folded &&
                                        layoutConfig.navbar.position === 'right' &&
                                        'md:mr-64'), style: !isEmbedCodesPage && !hideSidebar ? { marginTop: 82 } : {} },
                                    React.createElement("div", { className: classes.content },
                                        React.createElement(Message, null),
                                        renderRoutes(this.props.routes)),
                                    layoutConfig.footer.display && layoutConfig.footer.position === 'below' && footerTemplate),
                                layoutConfig.navbar.display && layoutConfig.navbar.position === 'right' && navBarTemplate),
                            layoutConfig.footer.display &&
                                layoutConfig.footer.style !== 'fixed' &&
                                layoutConfig.footer.position === 'above' &&
                                footerTemplate),
                        layoutConfig.footer.display &&
                            layoutConfig.footer.style === 'fixed' &&
                            layoutConfig.footer.position === 'above' &&
                            footerTemplate)));
            }
            case 'content':
            default: {
                return (React.createElement("div", { id: "fuse-layout", className: classNames(classes.root, layoutConfig.mode, 'scroll-' + layoutConfig.scroll) },
                    !isEmbedCodesPage && !hideSidebar && (React.createElement(Sidebar, { isPersistent: isPersistent, user: user, currentPath: this.props.location.pathname })),
                    layoutConfig.toolbar.display && layoutConfig.toolbar.position === 'above' && toolbarTemplate,
                    React.createElement("div", { className: classes.wrapper, style: {
                            zIndex: 2,
                        } },
                        layoutConfig.navbar.display && layoutConfig.navbar.position === 'left' && navBarTemplate,
                        layoutConfig.toolbar.display &&
                            layoutConfig.toolbar.position === 'below' &&
                            layoutConfig.toolbar.style === 'fixed' &&
                            toolbarTemplate,
                        React.createElement("div", { className: classNames(classes.contentWrapper, layoutConfig.navbar.display &&
                                layoutConfig.navbar.folded &&
                                layoutConfig.navbar.position === 'left' &&
                                'md:ml-64', layoutConfig.navbar.display &&
                                layoutConfig.navbar.folded &&
                                layoutConfig.navbar.position === 'right' &&
                                'md:mr-64'), style: !isEmbedCodesPage && !hideSidebar ? { marginTop: 82 } : {} },
                            React.createElement(Scrollbars, { className: classes.content },
                                React.createElement(Message, null),
                                renderRoutes(this.props.routes),
                                layoutConfig.footer.display &&
                                    layoutConfig.footer.position === 'below' &&
                                    layoutConfig.footer.style !== 'fixed' &&
                                    footerTemplate),
                            layoutConfig.footer.display &&
                                layoutConfig.footer.position === 'below' &&
                                layoutConfig.footer.style === 'fixed' &&
                                footerTemplate),
                        layoutConfig.navbar.display && layoutConfig.navbar.position === 'right' && navBarTemplate),
                    layoutConfig.footer.display && layoutConfig.footer.position === 'above' && footerTemplate));
            }
        }
    };
    Layout1.defaultProps = defaultProps;
    return Layout1;
}(React.PureComponent));
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setSettings: Actions.setSettings,
        setDefaultSettings: Actions.setDefaultSettings,
        resetSettings: Actions.resetSettings,
        navbarOpenFolded: Actions.navbarOpenFolded,
        navbarCloseFolded: Actions.navbarCloseFolded,
        navbarCloseMobile: Actions.navbarCloseMobile,
    }, dispatch);
}
function mapStateToProps(_a) {
    var auth = _a.auth, fuse = _a.fuse, sidebar = _a.sidebar;
    return {
        user: auth.user,
        defaultSettings: fuse.settings.defaults,
        settings: fuse.settings.current,
        navbar: fuse.navbar,
        tubeColor: auth.tube.color,
        originalOrgId: auth.user.originalOrgId,
    };
}
// @ts-ignore
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout1)));



//////////////////
// WEBPACK FOOTER
// ./src/theme/layout/layouts/Layout1.tsx
// module id = 1169
// module chunks = 81